import { styled } from '../../../stitches.config';

export const Body = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  margin: '0 0 0 calc(4 * $1)',
  padding: 0,
  flexGrow: 1,
});
